"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));

/* eslint-disable */
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M20.082 6.754l-4.511-4.511A.833.833 0 0014.98 2H5.328c-.92 0-1.667.746-1.667 1.667v16.666c0 .92.746 1.667 1.667 1.667H18.66c.92 0 1.667-.746 1.667-1.667V7.343a.833.833 0 00-.245-.589zM18.66 19.917a.417.417 0 01-.417.416h-12.5a.417.417 0 01-.416-.416V4.083a.417.417 0 01.416-.416h8.542c.115 0 .208.093.208.208v2.292c0 .92.747 1.666 1.667 1.666h2.292c.115 0 .208.094.208.209v11.875zm-2.707-9.835H8.037a.657.657 0 00-.667.666c0 .417.25.667.667.667h7.916c.333 0 .666-.25.666-.667a.657.657 0 00-.666-.666zm0 4.582H8.037a.657.657 0 00-.667.667c0 .333.25.667.667.667h7.916c.333 0 .666-.25.666-.667a.657.657 0 00-.666-.667z"
})), "0 0 24 24", "Document");

exports.default = _default;